// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + __webpack_require__.h().slice(0, 8) + ".js?v=9.16.18.16";
};